@if (field.inputType !== 'hidden') {
  <!-- use formGroups when we have multiple inputs (e.g. phone, contact person, ...) -->
  @if (hasMultipleFields) {
    @let formGroups = asFormGroups(formArray);

    @for (formGroup of formGroups; let groupIndex = $index; track groupIndex) {
      <ion-list class="proto-input-list dynamic-list" inset
        [formGroup]="formGroup"
        [ngClass]="{ 'has-remove-button': groupIndex > 0 || !field.isRequired }">
        @if (groupIndex > 0 || !field.isRequired) {
          <ion-button slot="start" color="danger" class="proto-button remove-button"
            (click)="removeDynamicField(groupIndex)">
            <ion-icon name="remove" slot="icon-only"></ion-icon>
          </ion-button>
        }

        @let controls = asFormGroupControls(formGroup);

        @for (control of controls; let controlIndex = $index; track controlIndex) {
          @let subField = asFormField(subFields[controlIndex]);

          <proto-form-field
            [attr.inert]="isSubFieldBlocked(subField.id) || null"
            [ngClass]="{
              'is-blocked': isSubFieldBlocked(subField.id),
              'data-review-changed': status === 'to-be-reviewed' && isSubFieldChanged(groupIndex, subField.id),
              'has-visible-hint': status === 'review-request' && subField.hintText
            }"
            [control]="control"
            [field]="subField"
            [status]="status"
            (valueUpdated)="valueUpdated.emit($event)"
            (openModal)="openModal.emit({ field: $event.field, formGroupIndex: groupIndex })"></proto-form-field>
        }
      </ion-list>
      @if (formGroup.hasError('personNameRequired') && formGroup.dirty) {
        <div class="proto-list-note proto-list-note--inset">
          {{ 'FORM.PERSON_NAME_ERROR_TEXT' | translate }}
        </div>
      }
    }
  } @else {
    <div class="dynamic-list-wrapper">
      <!--
          field.dynamicFieldConfig?.fields.length is always 1 here
          e.g. email field can have multiple inputs, but it has only one field config
      -->
      @let subField = asFormField(subFields[0]);

      @let controls = asFormArrayControls(formArray);

      @for (control of controls; let controlIndex = $index; track controlIndex) {
        <ion-list class="proto-input-list dynamic-list" inset
          [ngClass]="{ 'has-remove-button': controlIndex > 0 || !field.isRequired }">
          @if (controlIndex > 0 || !field.isRequired) {
            <ion-button slot="start" color="danger" class="proto-button remove-button" (click)="removeDynamicField(controlIndex)">
              <ion-icon name="remove" slot="icon-only"></ion-icon>
            </ion-button>
          }
          <proto-form-field
            [attr.inert]="isSubFieldBlocked(subField.id) || null"
            [ngClass]="{
              'is-blocked': isSubFieldBlocked(subField.id),
              'data-review-changed': status === 'to-be-reviewed' && isSubFieldChanged(controlIndex, subField.id),
              'has-visible-hint': status === 'review-request' && subField.hintText
            }"
            [control]="control"
            [field]="subField"
            [status]="status"
            (valueUpdated)="valueUpdated.emit($event)"
            (openModal)="openModal.emit($event)"></proto-form-field>
        </ion-list>
      }
    </div>
  }

  @if (status === 'to-be-reviewed' && groupHasChanged) {
    <small class="data-review-changed-info">{{ 'FORM.COMMON.INPUT_CHANGED' | translate }}</small>
  }

  @if (!isInSplitView || field.id !== 'topicsFreeText') {
    <ion-button color="primary" class="proto-button multi-add-button" fill="outline" expand="block"
      (click)="addDynamicField()">
      <ion-icon [name]="field.dynamicFieldConfig.icon" slot="start"></ion-icon>
      {{'FORM.BUTTON.ADD_FIELD' | translate: { key: (field.label | translate) } }}
    </ion-button>
  }
} @else {
  <input type="hidden" />
}
